import React, { useEffect, useRef, useState } from "react";
import { MenuIcon, PhoneIcon, XIcon } from "lucide-react";
import { firm, logos } from "../../data/site";
import { actionClass } from "../../utils/actionStyles";
import { DesktopNav } from "./DesktopNav";
import { MobileMenu } from "./MobileMenu";
const MENU_ID = "site-menu";
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!menuOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setMenuOpen(false);
        menuButtonRef.current?.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [menuOpen]);
  const logoAlt = `${firm.attorney}, The Motorcycle Lawyer — home`;
  return <header className="border-b border-line bg-white" data-id="element-116" data-mp="15gttfytz1gbl">
      <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between gap-3 px-4 py-3 md:gap-6 md:px-8 md:py-4" data-id="element-117" data-mp="15h3hhgvghden">
        <a href="/" className="shrink-0" data-id="element-118" data-mp="2vuuwgv7970qh">
          <img src={logos.desktop.src} width={logos.desktop.width} height={logos.desktop.height} alt={logoAlt} className="hidden h-[97px] w-[353px] md:block" data-id="element-119" data-mp="2vvwj7wxmtbo1" />
          <img src={logos.compact.src} width={logos.compact.width} height={logos.compact.height} alt={logoAlt} className="h-[63px] w-[62px] md:hidden" data-id="element-120" data-mp="2m5bbnjzzcwsz" />
        </a>

        <DesktopNav data-id="element-121" data-mp="30u7u8aznxs7u" />

        <div className="hidden items-center gap-5 nav:flex" data-id="element-122" data-mp="30uplet7gxg8w">
          <a href={firm.phoneHref} className="inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-ink hover:text-crimson" data-id="element-123" data-mp="30waleycjxre5">
            <PhoneIcon aria-hidden="true" className="h-5 w-5 text-crimson" data-id="element-124" data-mp="1pdhjqfo7ie8f" />
            <span className="sr-only" data-id="element-125" data-mp="1th5pqtx6x1rk">Call </span>
            {firm.phoneDisplay}
          </a>
          <a href="#case-review" className={actionClass("primary")} data-id="element-126" data-mp="3w1q8nuh5y01c">
            Free Case Review
          </a>
        </div>

        <div className="flex items-center gap-2.5 nav:hidden" data-id="element-127" data-mp="3r4qbya67e9mw">
          <button ref={menuButtonRef} type="button" aria-expanded={menuOpen} aria-controls={MENU_ID} onClick={() => setMenuOpen(open => !open)} className={actionClass("outline", "!px-3.5 sm:!px-5")} data-id="element-128" data-mp="3mc6psotga66h">
            {menuOpen ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-129" data-mp="38cnvozxh4vd6" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-130" data-mp="33dkq9edl0n4o" />}
            {menuOpen ? "Close" : "Menu"}
          </button>
          <a href={firm.phoneHref} className={actionClass("call", "!px-3.5 sm:!px-5")} data-id="element-131" data-mp="2yh3yma76bqmu">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-132" data-mp="11mhdaig7ywgy" />
            Call
            <span className="hidden xl:inline" data-id="element-133" data-mp="woz9f6h277ft">{firm.phoneDisplay}</span>
          </a>
          <a href="#case-review" className={actionClass("primary", "hidden lg:inline-flex")} data-id="element-134" data-mp="155q72npw4dxd">
            Free Case Review
          </a>
        </div>
      </div>

      {menuOpen && <MobileMenu id={MENU_ID} onNavigate={() => setMenuOpen(false)} data-id="element-135" data-mp="1dxiesqnj58y9" />}
    </header>;
}